import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  GET_SERIES_REPORT_REQUEST,
  GET_EXCEL_FILE_SERIES_REQUEST,
  POST_UNRESERVE_MARKING_CODES_SERIES_REQUEST,
  GET_SHORT_EXCEL_FILE_SERIES_REQUEST,
} from './constants';
import {
  getSeriesReportError,
  getSeriesReportRequest,
  getSeriesReportSuccess,
  getExcelFileSeriesError,
  getExcelFileSeriesRequest,
  getShortExcelFileSeriesRequest,
  getShortExcelFileSeriesError,
  getShortExcelFileSeriesSuccess,
  getExcelFileSeriesSuccess,
  postUnreserveMarkingCodesSeriesError,
  postUnreserveMarkingCodesSeriesRequest,
  postUnreserveMarkingCodesSeriesSuccess,
} from './actions';
import { Reports } from '../../../../entities/Reports/service';

function* getSeriesReportSaga(action: ReturnType<typeof getSeriesReportRequest>) {
  try {
    const response: AxiosResponse = yield call(Reports.getSeriesReport, action.payload);
    const seriesReport = response.data.ResponseBody;
    yield put(getSeriesReportSuccess(response.data?.UserText ? response.data?.UserText : seriesReport));
  } catch (e: any) {
    const error = e.toJSON();
    yield put(getSeriesReportError(error));
  }
}

function* getExcelFileSeriesRequestSaga(action: ReturnType<typeof getExcelFileSeriesRequest>) {
  try {
    yield call(Reports.getExcelSeriesReport, action.payload);
    yield put(getExcelFileSeriesSuccess());
  } catch (e: any) {
    const error = e.toJSON();
    yield put(getExcelFileSeriesError(error));
  }
}

function* getShortExcelFileSeriesRequestSaga(action: ReturnType<typeof getShortExcelFileSeriesRequest>) {
  try {
    yield call(Reports.getShortExcelSeriesReport, action.payload);
    yield put(getShortExcelFileSeriesSuccess());
  } catch (e: any) {
    const error = e.toJSON();
    yield put(getShortExcelFileSeriesError(error));
  }
}

function* postUnreserveMarkingCodesSeriesRequestSaga(
  action: ReturnType<typeof postUnreserveMarkingCodesSeriesRequest>,
) {
  try {
    const response: AxiosResponse = yield call(Reports.unreserveMarkingCodes, action.payload);
    const res = response.data.UserText;
    yield put(postUnreserveMarkingCodesSeriesSuccess(res));
    yield delay(3000);
    yield put(postUnreserveMarkingCodesSeriesSuccess(''));
  } catch (e: any) {
    const error = e.toJSON();
    yield put(postUnreserveMarkingCodesSeriesError(error));
  }
}

export function* SeriesReportSagaWatcher() {
  yield takeLatest(GET_SERIES_REPORT_REQUEST, getSeriesReportSaga);
  yield takeLatest(GET_EXCEL_FILE_SERIES_REQUEST, getExcelFileSeriesRequestSaga);
  yield takeLatest(GET_SHORT_EXCEL_FILE_SERIES_REQUEST, getShortExcelFileSeriesRequestSaga);
  yield takeLatest(POST_UNRESERVE_MARKING_CODES_SERIES_REQUEST, postUnreserveMarkingCodesSeriesRequestSaga);
}
